import { render, staticRenderFns } from "./LabelBankCard.vue?vue&type=template&id=40821e20&"
import script from "./LabelBankCard.vue?vue&type=script&lang=js&"
export * from "./LabelBankCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports